
<template>
    <div class= "col-md-12 ml-sm-0 col-lg-12 pt-0 px-0 pl-0">
        <div class="row mx-0">
            <div class="col-md-5 ml-sm-0 col-lg-5 pt-1 px-1 pl-5"></div>
            <div class="col-md-2 ml-sm-0 col-lg-2 pt-1 px-1 pl-5">
                <Select name="CapOpGroup" class="btn btn-default dropdown-toggle w-100" @change="updateDisplayBasedOnListChoice();" id="selectListCapOp">
                    <option id='Capex' selected>Capex</option>
                    <option id='Opex'>Opex</option>
                </Select>
            </div>
            <div class="col-md-5 ml-sm-0 col-lg-5 pt-1 px-1 pl-5"></div>
        </div>

        <!--Les inputs qui contiennent les datas des charts-->
        <input id="inputOpex" name="opex" style="visibility:hidden"/>
        <input id="inputCapex" name="capex" style="visibility:hidden"/>
        
        <div id="scale" name="divParams" class="row w-50 m-auto">
            <div class="col-md-3">
                <input v-model="scale" id="scaleXs" type="radio" name="scale" value="xs"/>
                <label for="scaleXs" class="disableInput">XS : &lt;= 500 kWC</label>
            </div>
            <div class="col-md-3">
                <input v-model="scale" id="scaleM" type="radio" name="scale" value="s"/>
                <label for="scaleM" class="disableInput">S : &lt;= 1000 kWC</label>
            </div>
            <div class="col-md-3">
                <input v-model="scale" id="scaleM" type="radio" name="scale" value="m"/>
                <label for="scaleM" class="disableInput">M : &lt;= 5 MWC</label>
            </div>
            <div class="col-md-3">
                <input v-model="scale" id="scaleL" type="radio" name="scale" value="l"/>
                <label for="scaleL" class="disableInput">L : &lt;= 20 MWC</label>
            </div>
        </div>
       
        <!--Le composant fille qui contients les charts-->
        <div id="charts" name="divParams" class= "row mx-0">
            <chartsCapexOpex :capex="capexopex[0].Capex" :opex="capexopex[1].Opex" :scale="scale" :mode="Mode"></chartsCapexOpex>
        </div>
    </div>
</template>

<script>
    import chartsCapexOpex from './charts/chartsCapexOpex.vue';
    
    export default {
        components: {
            chartsCapexOpex,
        },
        props : ['capexopex'],     
        
        data : function(){
            return {
                Capex :[],
                Opex:[],
                Implement:0,
                scale:'s',              
                Mode:"Capex",
            };
        },
        mounted: function(){
            this.Capex = JSON.parse(JSON.stringify(this.capexopex[0].Capex));
            this.Opex = JSON.parse(JSON.stringify(this.capexopex[1].Opex));
        },
        methods :{
            updateDisplayBasedOnListChoice() {
                var item = document.getElementById("selectListCapOp");
                this.Mode=item.value;
            }  
        }
    }

</script>
